<div id="wrapper">
	<app-loading-screen [status]="true"></app-loading-screen>
	<div>
		<app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
	</div>
	<div>
		<app-tab-nav 
			[visible]="false"
			(updatePostpaid)="this.postpago=$event" 
			(updatePrepaid)="this.prepago=$event"
			(updateFixed)="this.telefoniaFijo=$event" 
			(updateTotalAccountList)="this.totalAccountList=$event"
			(updateCurrentList)="this.currentList=$event" 
			(updateSelectBan)="this.selectBan=$event"
			(updateInitializeData)="this.initializeData()">
		</app-tab-nav>
	</div>
	<div class="allcont logsize m-top-i">
		<div class="basicrow ">
			<div class="container">
				<div class="">
					<div class="fulltitle  f-btitle autodef">
						<span class="icon-dash-27"></span> Suscripci&oacute;n a Netflix
					</div>
				</div>
			</div>
		</div>
		<div class="basicrow mbott m-top-i" id="last-div">
			<div class="container" *ngIf="this.screen==1">
				<div *ngIf="this.sw1==false && this.sw2==false" style="padding-bottom: 20px;">
					<div *ngIf="this.validationScreen=='sendCode'">
						<app-authentication-verification  (sw1)="this.sw1=$event" (validationScreen)="this.validationScreen=$event" [subscriberSelected]=this.subscriberSel></app-authentication-verification>	
					</div>
					<div *ngIf="this.validationScreen=='validCode'">
						<div class="neg center">
							Gracias por subscribirse a Netflix, para completar su solicitud debe ingresar <br>
							el código de seguridad enviado a su correo electrónico o celular
						</div>
						<div class="inputCode">
							<form [formGroup]="forgotForm">
								<div class="basicrow">
									<div class="basicrow requiredTrue">
										<input maxlength="6" class="inp-f" [appOnlyNumber] required formControlName="code" id="code">
										<div [hidden]="forgotForm.controls.code.valid || forgotForm.controls.code.untouched"
											class="alert alert-danger">
											Debe colocar un código valido.
										</div>
									</div>
								</div>
							</form>
						</div>
						<div class="basicrow f-reg f-black roboto-r center" style="padding-bottom: 15px;">
							Recuerda completar todos los pasos de suscripción a Netflix antes de salir de la página, de lo
							contrario la suscripción no será exitosa y no podrás disfrutar del servicio.
						</div>
						<div class="basicrow f-reg f-black roboto-r center">
							Ser&aacute;s redirigido al portal de netflix donde debes completar la suscripci&oacute;n de
							<span class="roboto-b">Servicios Netflix.</span>
						</div>
						<div class="basicrow m-top-i">
							<div class="logline full"></div>
						</div>
						<div class="basicrow text-center m-top">
							<input type="checkbox" id="idTermsAndConditionsNet" style="cursor: pointer;"> <span
								(click)="this.showterms();" class="linkdefsnet">Acepto los T&eacute;rminos y
								Condiciones&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></span>
						</div>
						<div class="basicrow text-center m-top" style="padding-bottom: 30px;">
							<a (click)="this.validTerm()" class="red btns def-i centr vcenter">
								<span class="tabcell">
									Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
								</span>
							</a>
						</div>
					</div>
				</div>
				<div *ngIf="this.sw1==false && this.sw2==true" style="padding-bottom: 20px;">
					<div class="basicrow f-reg f-black roboto-r text-justify">
						<span>
							Estimado cliente este suscriptor no aplica para la suscripción de Netflix.
						</span>
					</div>
					<div class="basicrow m-top-i">
						<div class="logline full"></div>
					</div>
					<div class="basicrow text-center m-top" style="padding-bottom: 30px;">
						<a (click)="this.cancel()" ui-sref="netflix" class="btns def-i gray pull-left vcenter">
							<span class="tabcell">
								Cancelar
							</span>
						</a>
					</div>
				</div>
				<div class="basicrow mbott bg-gray allpads bg-gray-u f-reg roboto-r f-black text-justify"
					*ngIf="this.sw1==true && this.subscriberCounter>0">
					Selecciona el <span class="roboto-b">n&uacute;mero de cuenta y n&uacute;mero de suscriptor</span>
					donde desea agregar el Servicio Netflix:
				</div>
				<div class="basicrow mbott bg-gray allpads bg-gray-u f-reg roboto-r f-black text-justify"
					*ngIf="this.sw1==true && this.subscriberCounter==0">
					<span class="roboto-b"> Su número de cuenta ya tiene un servicio activo de subscripción a
						Netflix.</span>
				</div>
				<div class="autowcont notopbrd" *ngIf="this.sw1==true">
					<div *ngFor="let offer of this.offers['offers']; let i = index">
						<div *ngIf="offer.offers[0].status=='true'">
							<div data-toggle="collapse" [attr.data-target]="'#tabC_'+i" class="digs-box-f vcenter mob-txt" (click)="updateExpand(i)" [ngClass]="{'mon': this.expand[i] == true,'': this.expand[i] == false}">
								<div class="tabcell">
									<div class="autorow pull-left">
										Cuenta {{offer.offers[0].ban}}
									</div>
									<div class="autorow pull-right">
										<i class="fa fa-minus" aria-hidden="true"></i>
										<i class="fa fa-plus" aria-hidden="true"></i>
									</div>
								</div>
							</div>
							<div id="tabC_{{i}}" class="collapse" [ngClass]="{'show': i == 0,'': i > 0}">
								<div id="slides_control" class="slides_web">
									<div *ngFor="let subscribers of offer.offers[0].offers; let k = index">
										<div class="optchoice auto roboto-r text-left" id="optNetflix_{{i}}_{{k}}"
											(click)="this.activarOpcion(i,k,this.offers.offers);" *ngIf="subscribers.netFlixBlackListed=='false' && subscribers.status!='S'">
											<div class="checkdef">
												<input type="radio" id="optCheckNetflix_{{i}}_{{k}}" name="netflx1"
													class="css-radio"><label for="netflx1"
													class="css-label3 radGroup1"></label>
											</div>
											<div class="basicrow f-reg roboto-b">
												Suscriptor<br />
												<span class="f-red f-bmed">
													{{subscribers.subscriber}}
												</span>
											</div>
										</div>
										<div class="optchoice auto roboto-r text-left on2" id="optNetflix_{{i}}_{{k}}" *ngIf="subscribers.netFlixBlackListed=='true'">
											<div class="checkdef">
												<input type="radio" id="optCheckNetflix_{{i}}_{{k}}" name="netflx1"
													class="css-radio"><label for="netflx1"
													class="css-label3 radGroup1"></label>
											</div>
											<div class="basicrow f-reg roboto-b">
												Suscriptor<br />
												<span class="f-bmed">
													{{subscribers.subscriber}}
												</span> (No aplica para Netflix)
											</div>
										</div>
									</div>
								</div>
								<div class="espacio" *ngIf="offer.offers[0].offers.length > 0">
									<div class="basicrow">
										<div class="basicrow m-top-i">
											<div class="logline full"></div>
										</div>
										<div class="basicrow text-center m-top">
											<a class="btns def-i red pull-right vcenter"
												(click)="this.activarNetflixMult(offer.offers[0].peperless);">
												<span class="tabcell">
													Continuar&nbsp;&nbsp;<i class="fa fa-angle-right"
														aria-hidden="true"></i>
												</span>
											</a>
											<a ui-sref="netflix" class="btns def-i gray pull-left vcenter">
												<span class="tabcell" (click)="this.cancel()">
													Cancelar
												</span>
											</a>
										</div>
									</div>
								</div>
								<div class=" textData basicrow topbord-i allpads  f-reg roboto-r f-black text-justify" *ngIf="offer.offers[0].offers.length==0">
									Esta cuenta no tienes suscriptores.
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<app-footer></app-footer>
</div>